import React from 'react';
import swal from 'sweetalert';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';


export const updateProfile = object => ({
    type: 'UPDATE_PROFILE',
    payload: object,
});

export function getPartnerUserColumn() {
    return [{
        accessor: 'Name',
        Header: 'Name',
    }, {
        accessor: 'Email',
        Header: 'Email',
    }, {
        accessor: 'HomePhone',
        Header: 'Home Phone',
    }, {
        accessor: 'MobilePhone',
        Header: 'Mobile Phone',
    }, {
        accessor: 'Partner_Authority__c',
        Header: 'Partner Authority',
        Filter: ({ filter, onChange }) => (
            <select
                onChange={event => onChange(event.target.value)}
                className="form-control"
                value={filter ? filter.value : ''}
            >
                <option value="">All</option>
                <option value="Approver">Approver</option>
                <option value="Verifier">Verifier</option>
            </select>
        ),
    }, {
        accessor: 'Active__c',
        Header: 'Status',
        Filter: ({ filter, onChange }) => {
            console.log(filter)
            return (
                <select
                    onChange={event => onChange(event.target.value)}
                    className="form-control"
                    value={filter ? filter.value : ''}
                >
                    <option value="">All</option>
                    <option value="true">Active</option>
                    <option value="false">Not Active</option>
                </select>
            );
        },
        width: 80,
        Cell: colProps => {
            return (colProps.value === 'true' ? <i className="fa fa-check text-center" /> : <i className="fa text-center fa-times" />);
        },
    }, {
        accessor: 'Id',
        Header: 'Actions',
        width: 250,
        filterable: false,
        Cell: (colProps) => {
            const buttons = [
                <button className="btn btn-sm btn-primary btn-fill" 
                onClick={() => this.setState({ showModal: true, form: colProps.row, editMode: true })} 
                key={`buttonEdit${colProps.value}`}
                disabled={this.props.user.loggedInUser.Partner_Authority__c === "Verifier"}
                >
                    <i className="fa fa-pencil" /> Edit
                </button>,
            ];
            /*
            <button className="btn btn-sm btn-danger btn-fill" onClick={() => this.deletePartner(colProps.value)} key={`buttonDelete${colProps.value}`}>
                    <i className="fa fa-trash" /> Delete
            </button>,
            */
            return (
                <div className="btn-group" role="group" aria-label="...">
                    {buttons}
                </div>
            );
        },
    }];
}

/*
    Getting all user based on Agency/School tagged
    this functions need to be bind with main components
*/
export async function getAllPartnerUser() {
    if (this.state.loading) return;
    this.setState({ loading: true });
    const { loggedInUser } = this.props.user;
    
    try {
        const partnersUser = await fetch(`${spmfcloudFunctionUrl}/users/all-partner`, {
            mode: 'cors',
            cache: 'no-cache',
            method: 'GET',
            headers: {
                'hash-token': this.props.user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then(async (response) => {
            const json = await response.json();
            if (!response.ok) throw new Error(json.message);
            return json;
        }).then((json) => {
            const cloneJson = Object.assign({}, json);
            cloneJson.records = json.records.map((rec) => {
                const clone = Object.assign({}, (rec));
                clone.Active__c = `${clone.Active__c}`;
                return clone;
            });
            return cloneJson;
        });

        this.setState({ list: partnersUser.records, loading: false });
    } catch (error) {
        swal({
            text: error.toString(),
            title: 'Error when getting user',
        });
    }
}

export function emailAlreadyExist(email, siteToken) {
    return fetch(`${spmfcloudFunctionUrl}/users/check-email?email=${email}`, {
        mode: 'cors',
        cache: 'no-cache',
        method: 'GET',
        headers: {
            'hash-token': siteToken,
            'Content-Type': 'application/json',
        },
    }).then(response => response.json());
}
export async function save(e) {
    try {
        e.preventDefault();
        if (this.state.loading) return;

        const {
            Name, Email, HomePhone, MobilePhone, Active__c, Password__c, Id,
        } = this.state.form;
        // we removed picklist so set the default value;
        const Partner_Authority__c = 'Verifier';
        const names = Name.split(' ');
        const formValue = {
            lastName: names.length === 1 ? 'NA' : names.pop(),
            firstName: names.length === 1 ? names[0] : names.join(' '),
            Email,
            HomePhone,
            MobilePhone,
            Partner_Authority__c,
            Active__c,
        };

        formValue.AccountId = this.props.user.loggedInUser.AccountId;
        formValue.Active__c = Active__c === 'true';
        formValue.RecordType = {
            Name: 'Partner',
        };

        if (Password__c) {
            if (Password__c.length > 0) {
                // Complete special chars
                // ,./;'[]\<>?:"{}|!@#$%^&*()_+-=`~
                // Original special chars
                // .$@$!%*#?&
                const validPassword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[.$@$!%*#?&])[A-Za-z\d.$@$!%*#?&]{8,}$/.test(Password__c);
                if (!validPassword) {
                    swal({
                        text: 'Password must have at least 8 characters including at least one letter, one number and one special character (i.e. .$@$!%*#?&)',
                        title: 'Change Password',
                    });
                    return;
                }
                formValue.Password__c = Password__c;
            }
        } else if (this.state.editMode === false) {
            swal({
                text: 'Password can\'t be blank',
                title: 'Blank Password',
            });
            return;
        }

        // if (this.state.editMode) formValue.Id = Id;
        this.setState({ loading: true });

        const response = await emailAlreadyExist(Email, this.props.user.siteToken.hash);
        if (response.records.length > 0) {
            // Email is already registered.
            // Check if this is user creation or user update
            if (this.state.editMode) {
                // User update
                // Check if it belongs to this particular user.
                if (response.records[0].Id === Id) {
                    // Do update
                    formValue.Id = Id;
                } else {
                    // Throw an error because you can't use someone else's email
                    throw new Error('The email is already used by another account');
                }
            } else {
                // User creation
                // Throw an error because you can't use someone else's email
                throw new Error('The email is already used by another account');
            }
        } else if (this.state.editMode) {
            formValue.Id = Id;
        }

        const result = await fetch(`${spmfcloudFunctionUrl}/users/partner-user`, {
            mode: 'cors',
            cache: 'no-cache',
            method: this.state.editMode ? 'PATCH' : 'POST',
            body: JSON.stringify(formValue),
            headers: {
                'hash-token': this.props.user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then(async (resp) => {
            const json = await resp.json();
            if (!resp.ok) {
                throw new Error(json.message);
            }
            return json;
        });
        this.setState({ loading: false, form: {}, showModal: false });
        swal({
            text: result.message,
            title: 'Success',
        });
        this.getAllPartnerUser();
    } catch (error) {
        swal({
            text: error.message,
            dangerMode: true,
            title: 'Error',
        });
        this.setState({ loading: false });
    }
}

export async function deletePartner(id) {
    if (this.state.loading) return;
    const willDelete = await swal({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to recover this partner.',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
    });
    if (!willDelete) return;
    this.setState({ loading: true });
    try {
        const result = await fetch(`${spmfcloudFunctionUrl}/delete-contact/${id}`, {
            mode: 'cors',
            cache: 'no-cache',
            method: 'DELETE',
            headers: {
                'hash-token': this.props.user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then(async (response) => {
            if (response.status !== 200) {
                const json = await response.json();
                throw (new Error(json.message));
            }
            return response.json();
        });
        this.setState({ loading: false, form: {}, showModal: false });
        swal({
            text: result.message,
            title: 'Success',
        });
        this.getAllPartnerUser();
    } catch (error) {
        swal({
            text: `${error}`,
            dangerMode: true,
            title: 'Error',
        });
        this.setState({ loading: false });
    }
}

export default null;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/UserManagement/actions.js
// module id = 474
// module chunks = 0